import React from 'react';

import { InputEditor } from './styles';

type EditableNodeProps = {
  value: string;
  placeholder?: string | null;
  onValidate?: (value: string) => React.ReactNode | null | undefined;
  onChange: (value: string, canceled: boolean) => void;
};

type EditableNodeState = {
  value: string;
};

export default class EditableNode extends React.Component<EditableNodeProps, EditableNodeState> {
  static defaultProps = {
    value: '',
    placeholder: ''
  };

  constructor(props: EditableNodeProps) {
    super(props);

    this.state = {
      value: props.value
    };

    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleEditExit = this.handleEditExit.bind(this);
  }

  handleValueChange(value: string) {
    this.setState({
      value
    });
  }

  handleEditExit(value?: string, data?: { canceled?: boolean } | undefined) {
    this.props.onChange(value || '', !!data?.canceled);
  }

  render() {
    const { onValidate, placeholder } = this.props;
    const { value } = this.state;
    return (
      <InputEditor
        autoSelect
        initialEditMode
        required
        value={value}
        placeholder={placeholder || ''}
        onValidate={onValidate}
        onChange={this.handleValueChange}
        onEditExit={this.handleEditExit}
      />
    );
  }
}
